__turbopack_context__.v({
  "author": "author-module-scss-module__uqdQGa__author",
  "fancy": "author-module-scss-module__uqdQGa__fancy",
  "image": "author-module-scss-module__uqdQGa__image",
  "imageContainer": "author-module-scss-module__uqdQGa__imageContainer",
  "images": "author-module-scss-module__uqdQGa__images",
  "simple": "author-module-scss-module__uqdQGa__simple",
  "subtitle": "author-module-scss-module__uqdQGa__subtitle",
  "title": "author-module-scss-module__uqdQGa__title",
});
